import axios from '../../../utils/axios';
import { useInviteTeamMember } from '../InviteTeamMemberContext';
import { useIntl } from 'react-intl';
import { useQuery } from '@tanstack/react-query';

export const useActiveProperties = (company, companyRole) => {
  const intl = useIntl();
  const t = id => intl.formatMessage({ id });

  const { setLoading, setErrors } = useInviteTeamMember();

  return useQuery({
    enabled: !!company && !!companyRole,
    queryKey: ['activeProperties', company],
    queryFn: async () => {
      try {
        setLoading(true);
        setErrors([]);

        const encodedCompany = encodeURIComponent(company);

        const result = await axios.get(`/properties/${encodedCompany}?status=active`);

        if (result.status === 200) {
          let props = result.data.data
            .map(p => {
              if (!p.displayName) p.displayName = p.name;
              return p;
            })
            .sort((a, b) => (a.displayName > b.displayName ? 1 : -1));
          props.forEach(p => {
            p.roleId = companyRole.value;
          });
          return props;
        }
      } catch (e) {
        if (e.response && e.response.data) {
          setErrors(`${t('error.serverData')} (${e.response.data.errors})`);
        } else {
          setErrors((e && e.message) || t('error.server'));
        }
      } finally {
        setLoading(false);
      }
    },
    refetchOnWindowFocus: false
  });

};
